/**
 * v5.7 Addition 22 — dual scope toggle for Reporting screens.
 * Purely local to each report. Does NOT touch the Global Pipeline Switcher.
 */
export default function ScopeToggle({ value, onChange }) {
  return (
    <div
      className="inline-flex rounded-md border p-0.5"
      style={{ borderColor: "var(--cw-border)" }}
      data-testid="report-scope-toggle"
    >
      <button
        onClick={() => onChange("pipeline")}
        className="px-3 py-1.5 text-xs font-medium rounded transition"
        style={
          value === "pipeline"
            ? { background: "var(--cw-primary)", color: "white" }
            : { color: "var(--cw-muted)" }
        }
        data-testid="report-scope-pipeline"
      >
        This Pipeline
      </button>
      <button
        onClick={() => onChange("tenant")}
        className="px-3 py-1.5 text-xs font-medium rounded transition"
        style={
          value === "tenant"
            ? { background: "var(--cw-primary)", color: "white" }
            : { color: "var(--cw-muted)" }
        }
        data-testid="report-scope-tenant"
      >
        All Pipelines
      </button>
    </div>
  );
}
